<style lang="css" scoped>
h1 {
  padding: 0;
}

h1 {
  white-space: wrap;
}

.v-btn.outlined {
  border: 1px solid #f00;
  border-radius: 50%;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #eeeeee;
  margin: 1em 0;
  padding: 0;
}

.dryContact {
  max-height: 40px;
  width: auto;
}

.magnet {
  max-height: 50px;
  width: auto;
}

.center-input {
  text-align: center;
}
.center-input::-webkit-input-placeholder {
   text-align: center;
}
.center-input:-moz-placeholder { /* Firefox 18- */
   text-align: center;
}
.center-input::-moz-placeholder {  /* Firefox 19+ */
   text-align: center;
}
.center-input:-ms-input-placeholder {
   text-align: center;
}

.switchBar {
  border-bottom: 2px solid #eeeeee;
}
@media screen and (min-width: 600px) {
  .switchBar {
    border: 2px solid #eeeeee;
  }
}
@media screen and (max-width: 600px) {
  .itemTitle, .limitWidth{
    width: 100%;
    max-width: calc(100vw - 186px);
  }
}

</style>

<template>

  <v-layout row wrap v-if="item">
    <v-flex xs12>
      <template flat>
        <div class="switchBar py-2" :status="dir + (item.role == 0 ? '-Sensor-' : '-') + item.status">
          <v-layout row wrap align-center justify-content-between class="px-2">
            <v-flex class="itemTitle">
              <h1 class="dark--text">
                {{item.name}}
              </h1>
              <small id="identifier">{{item.identifier}}</small>
            </v-flex>

            <v-spacer></v-spacer>

            <ModeBtns v-if="item.connection && item.role == 1" :slug="item.slug" />

            <v-flex v-if="item.status == 'Offline'" class="mr-2" shrink>
              <span class="title grey--text text--darken-2">{{content.not_connected}}</span>
            </v-flex>
            <v-flex v-if="item.exceeds" d-flex nowrap row shrink>
              <span class="title white--text">{{content.exceeds}}</span>
            </v-flex>
            <v-flex v-if="item.connection && item.type == 2" d-flex nowrap row shrink class="mr-2">
              <battery :type="item.data.type.name" :voltage="item.data.battery" :key="item.data.battery" />
            </v-flex>
          </v-layout>
        </div>
      </template>
    </v-flex>

    <v-flex xs12>
      <section v-if="item.status !== 'Offline'">

        <v-layout v-if="item.data.dudtype < 4 && item.data.temperatures && item.data.temperatures[0]" row wrap justify-space-around class="my-2" dir="ltr">
          <v-flex v-if="item.data.dudtype >= 1" v-for="temp in item.data.temperatures" :key="temp" align-center class="text-xs-center">
            <small class="title blue--text text--darken-2" dir="ltr">
              <v-icon medium color="blue">ac_unit</v-icon> {{temp}}℃
            </small>
          </v-flex>
          <v-flex v-if="item.data.dudtype >= 2" align-center class="text-xs-center">
            <small class="title cyan--text" dir="ltr">
              <v-icon medium color="cyan lighten-3">opacity</v-icon> {{item.data.humidity}}%
            </small>
          </v-flex>
          <v-flex v-if="item.data.dudtype >= 3" align-center class="text-xs-center">
            <small class="title yellow--text text--darken-2" dir="ltr">
              <v-icon medium color="yellow darken-1">wb_incandescent</v-icon> {{item.data.light}}<small> lx</small>
            </small>
          </v-flex>
        </v-layout>

        <v-layout v-if="item.data.dudtype == 4" row wrap justify-center>
          <v-flex v-if="item.data.drycontact == 0" align-center class="text-xs-center py-3">
            <span class="title teal--text text--darken-2">{{content.sensor_open}}</span>
          </v-flex>
          <v-flex v-if="item.data.drycontact == 1" align-center class="text-xs-center py-3 bg-red">
            <span class="title red--text text--darken-4">{{content.sensor_close}}</span>
          </v-flex>
          <v-flex v-if="item.data.hall == 1" align-center class="text-xs-center py-3">
            <span class="title teal--text text--darken-2">{{content.magnet_true}}</span>
          </v-flex>
          <v-flex v-if="item.data.hall == 0" align-center class="text-xs-center py-3 bg-red">
            <span class="title red--text text--darken-4">{{content.magnet_false}}</span>
          </v-flex>
        </v-layout>

        <v-layout v-if="!item.sensors" row wrap justify-center text-xs-center>
          <h2 class="my-2 red--text text--darken-4">{{content.no_sensor}}</h2>
        </v-layout>

        <v-layout v-if="item.data.dudtype === 4" row wrap justify-center>
          <v-flex v-if="'drycontact' in item.data" class="ma-2 text-xs-center">
            <img src="/images/drycontact.svg" alt="dry contact icon" class="dryContact">
          </v-flex>
          <v-flex v-if="'hall' in item.data" class="ma-2 text-xs-center">
            <img src="/images/magnet.svg" alt="magnet icon" class="magnet">
          </v-flex>
        </v-layout>

        <hr v-if="item.data.dudtype > 0" class="mb-0">

        <v-layout v-if="item.data.rssi" row wrap>
          <rssi :slug="item.slug" :key="item.slug" />
        </v-layout>

        <v-layout v-if="item.data.dudtype !== 4 && item.devmodes > 1" class="my-3" row wrap>
          <!--  !!!!!!  -  Devmode Form  -  !!!!!!   -->
          <v-flex xs12>
            <devmode :locale="locale" :devmodes="item.devmodes" :key="item.slug"></devmode>
          </v-flex>

          <!--  !!!!!!  -  Threshold Form  -  !!!!!!   -->
          <v-flex xs12 v-if="item.devmodes > 0">
            <threshold :locale="locale" :key="item.slug"></threshold>
          </v-flex>
        </v-layout>

        <!--  !!!!!!  -  Schedule  -  !!!!!!   -->
        <schedule v-if="item.role != 0" :locale="locale" :action="reqScheduleAction" :key="item.slug" class="mt-2" />

        <!--  !!!!!!  -  Map Iframe  -  !!!!!!   -->
        <v-layout v-if="item.type == 3" row wrap justify-center>
          <v-flex grow :key="item.data.gps.latitude+item.data.gps.longitude">
            <iframe :src="'https://maps.google.com/maps?q='+item.data.gps.latitude+','+item.data.gps.longitude+'&hl='+this.locale+'&z=14&amp;output=embed'" width="100%" height="300" frameborder="0" style="border:0" allowfullscreen></iframe>
          </v-flex>
        </v-layout>

      </section>

      <section v-else>
        <p class="display-1 text-xs-center py-5 my-4 px-2">
          {{content.device_off}}
        </p>
      </section>

      <!--  !!!!!!  -  Graphs  -  !!!!!!   -->
      <section id="graph">
        <graph v-if="item.connection" :slug="item.slug" :type="item.data.dudtype" :role="item.role" :devmode="item.data.dudtype == 4 ? 0 :item.data.devmode" />
      </section>

      <!--  !!!!!!  -  Settings  -  !!!!!!   -->
      <v-layout row wrap justify-center class="mt-4 mb-2">
        <Settings :name="item.name" :role="item.role" :slug="item.slug" :type="item.type" :key="item.slug" />
      </v-layout>

      <v-layout row wrap justify-center class="mt-4 mb-2">
        <v-flex text-xs-center class="grey--text text--lighten-1">
          {{content.last_update}}: <span dir="ltr">{{item.last_update}}</span>
        </v-flex>
      </v-layout>

    </v-flex>

    <Reqschedule :slug="item.slug" :status="(Object.keys(item.data.schedule).length < 1) && (item.data.mode == 0) ? true : false" @reqScheduleEvent="reqScheduleAnswer" />

  </v-layout>

</template>

<script>

import { mapGetters } from 'vuex'
import ModeBtns from "../Devices/modebtns"
import Battery from "../tools/battery"
import Rssi from "../tools/rssi"
import Devmode from './edit/devmode'
import Threshold from './edit/threshold'
import Schedule from './schedule'
import Reqschedule from './schedule-required'
import Settings from './itemsettings'
import Graph from '../tools/itemgraph'
export default {
  components: { ModeBtns, Battery, Rssi, Devmode, Threshold, Schedule, Reqschedule, Graph, Settings },
  props: ['locale', 'dir',],
  data() {
    return {
      loadingBtn: null,
      loadingDevmode: null,
      loadingThreshold: null,
      threshold: {
        icons: {
            'temp': '℃',
            'humidity': '%',
            'light': 'lx'
        },
        icon: '',
        btn: {
            color: 'blue',
            icon: 'edit',
            loading: false
        }
      },
      devmode: {
        status: null,
        icon: null,
        color: null
      },

      icons: [{
          icon: "timer",
          color: "blue darken-4"
      }, {
          icon: "wb_sunny",
          color: "yellow darken-2"
      }, {
          icon: "ac_unit",
          color: "blue"
      }, {
          icon: "opacity",
          color: "cyan lighten-3"
      }, {
          icon: "format_color_reset",
          color: "cyan lighten-3"
      }, {
          icon: "wb_incandescent",
          color: "yellow darken-1"
      }, {
          icon: "wb_incandescent",
          color: "grey lighten-1"
      }],

      reqScheduleAction: null,

    }
  },
  computed: {
     ...mapGetters(['devices/device']),
    item: function (getter) {
      return getter['devices/device'](this.$route.params.slug);
    }
  },
  created(){
    this.setLang();
  },
  methods: {
    reqScheduleAnswer(answer){
      this.reqScheduleAction = answer;
    },

    setLang() {
        if (this.locale == "en") {
            this.content = {
                device_off: "The device has no power or internet connection",
                not_connected: "Not Connected",
                no_sensor: 'Sensor is not connected',
                sensor_open: 'The buoy is in a normal state',
                sensor_close: 'Warning of flooding!',
                magnet_true: 'Detects a magnet nearby',
                magnet_false: 'A magnet is not detected',
                exceeds: 'Exceeds the threshold',
                agree: 'Agree',
                cancel: 'Cancel',
                last_update: 'Last Update',
            };

        } else if (this.locale == "he") {
            this.content = {
                device_off: "לבקר אין חיבור לחשמל או לאינטרנט",
                not_connected: "לא מחובר",
                no_sensor: 'חיישן אינו מחובר',
                sensor_open: 'המצוף במצב תקין',
                sensor_close: 'אזהרת הצפה!',
                magnet_true: 'מזהה מגנט קרוב',
                magnet_false: 'לא מזהה מגנט',
                exceeds: 'חורג מהסף',
                agree: 'מסכים',
                cancel: 'ביטול',
                last_update: 'עדכון אחרון',
            };
        }
    }
  }
}

</script>
